<!-- (1) IF USER IS NOT SIGNED IN & NOT SUBSCRIBED-->
<!-- <CallToActionJoin /> shows 'Get Notified' button  -->
<!-- Clicking on <CallToActionJoin /> adds #join to URL -->
<!-- This triggers <AppModalJoin> to mount <AppModalIFrame> -->
<!-- This opens fullstack.vizbi.org/transparent#join -->
<!-- (2) IF USER IS SIGNED IN & NOT SUBSCRIBED-->
<!-- <CallToActionJoin /> shows 'Join Our Community' button  -->
<!-- Clicking button adds #subscribe to URL -->
<!-- This triggers <AppModalJoin> to mount <AppModalIFrame> -->
<!-- This opens fullstack.vizbi.org/transparent#subscribe, full-window -->
<!-- (3) IF USER IS SIGNED IN & SUBSCRIBED-->
<!-- <CallToAction /> banner is hidden  -->
<!-- <MailingList /> button is shown  -->
<!-- Clicking the button triggers <AppModalSubscribe> to mount <AppModalIFrame> -->
<!-- This opens fullstack.vizbi.org/transparent#subscribe, full-window -->

<!-- your_email+clerk_test@example.com  |  test code: 424242 -->

<template>
  <div id="banner" ref="banner" :class="{hideForm: route.name === 'Form'}">
    <span class="left-text" />
    <div class="center-content">
      <CallToActionJoin v-if="!isSubscribed" />
    </div>
    <span class="right-text" />
  </div>
</template>

<script setup>
// const log = (msg) => process.env.VUE_APP_DEV && console.log(`Banner: ${msg}`); // eslint-disable-line
const log = (msg) => console.log(`Banner: ${msg}`);

import {inject, nextTick, ref, watch} from "vue";
import {useRoute} from "vue-router";
import CallToActionJoin from "@/components/CallToAction/Join";
import {setCallToActionStyle} from "@/composables/useBackground"; // fit to call-to-action

const isSubscribed = inject("isSubscribed");
const displayWidth = inject("displayWidth"); // from App.vue > composable/
const banner = ref(null);
const route = useRoute(); // access the current route object
let height = "70px"; // initially, set to default for narrow displays
function setBannerHeight() {
  log(`setBannerHeight()`);
  if (isSubscribed.value) {
    height = "0px";
  } else if (displayWidth.value === "narrow") {
    height = "70px";
  } else if (displayWidth.value === "medium") {
    height = "90px";
  } else if (displayWidth.value === "wide") {
    height = "95px";
  } else if (displayWidth.value === "unlimited") {
    height = "100px";
  }
  log(`displayWidth = ${displayWidth.value}`);
  log(`height = ${height}`);
  log(`isSubscribed = ${isSubscribed.value}`);
  //banner.value.style.height = height; // Set desired height for <div></div>
  // Use nextTick to apply styles after Vue has completed the DOM update
  nextTick(() => {
    // if (!banner?.value) return;
    banner.value.style.height = height;
    setCallToActionStyle(height, "black"); // Adjust <body>
  });
}
// Reset div's height once banner is in the DOM, and whenever isSubscribed changes
watch([banner, isSubscribed], ([newBannerValue]) => {
  log(`isSubscribed = ${isSubscribed.value}`);
  if (!newBannerValue) return log("Banner element not yet in DOM");
  setBannerHeight();
});
// hide CTA on the Registration/Form page:
watch(
  () => route.name,
  (newRouteName, oldRouteName) => {
    log(`[newRouteName, oldRouteName] = ${newRouteName}, ${oldRouteName}]`);
    if (newRouteName === "Form") {
      log(`Hide CTA `);
      setCallToActionStyle("0px", "#000");
    } else if (oldRouteName === "Form") {
      log(`Reveal CTA`);
      setBannerHeight();
    }
  }
);
// resize CTA with displayWidth changes
watch(displayWidth, (newDisplayWidth, oldisplayWidth) => {
  log(`[newDisplayWidth, oldisplayWidth] = ${newDisplayWidth}, ${oldisplayWidth}]`);
  if (route.name === "Form") return; // no change
  if (newDisplayWidth === oldisplayWidth) return; // no change
  setBannerHeight();
});
</script>

<style scoped>
#banner {
  display: flex;
  position: relative; /* Ensure absolute positioning is relative to this element */
  justify-content: space-between; /* Keeps left and right text at the sides */
  align-items: center;
  color: white;
  font-size: 0.99rem;
  padding: 0 1.05rem 0 0.75rem;
  line-height: 1.05;
}
:is(.wide #banner, .medium #banner) {
  font-size: clamp(1.2rem, 4vw, 1.73rem); /* min, preferred, max was: 3.12em; */
}
.unlimited #banner {
  font-size: 1.73rem;
  height: 100px;
}
.left-text {
  margin-right: auto;
}
.right-text {
  margin-left: auto;
}
.left-text span {
  display: inline;
}
.center-content {
  display: flex;
  justify-content: center;
  flex-grow: 1;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
#lineBreak {
  display: block; /* Forces a new line */
}
#lineBreak span {
  display: inline; /* prevent above new line */
}
.hideForm {
  display: none; /* Or 'visibility: hidden;' if you want to keep the space */
}
</style>
